// BlitzHeader.jsx - Updated to support mobile actions instead of menu button
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  ThemeProvider,
  useTheme,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import blitzLogo from './globalAssets/logo_placeholder.png';
import routes from "../Config/routes";
import { lightTheme } from "../Utils/baseTheme";

const BlitzHeader = ({ 
  menuButton, 
  children, 
  isDesktop: isDesktopProp, 
  mobileActions = [] 
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktop = typeof isDesktopProp === 'boolean' ? isDesktopProp : upMd;

  return (
    <ThemeProvider theme={lightTheme}>
      <AppBar
        id='MobileHeader'
        position="fixed"
      >
        <Toolbar>
          <Box 
            display='flex' 
            flexDirection='row' 
            justifyContent='space-between' 
            alignItems='center' 
            flex={1} 
            maxHeight='100%'
          >
            {isDesktop ? (
              <>
                {/* Desktop: Menu button first, then logo */}
                {menuButton}
                <Box margin={0} flex={1}>
                  <IconButton
                    color="inherit"
                    aria-label="logo"
                    sx={{
                      margin: 0,
                      padding: 0,
                      ml: 1,
                      "&.MuiButtonBase-root:hover": {
                        bgcolor: "transparent"
                      }
                    }}
                    onClick={() => navigate(routes.dashboard)}
                  >
                    <img
                      src={blitzLogo}
                      alt="logo"
                      style={{ height: "45px" }}
                    />
                  </IconButton>
                </Box>
                {children}
              </>
            ) : (
              <>
                {/* Mobile: Logo first */}
                <Box margin={0} flex={1}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="logo"
                    sx={{
                      margin: 0,
                      padding: 0,
                      "&.MuiButtonBase-root:hover": {
                        bgcolor: "transparent"
                      }
                    }}
                    onClick={() => navigate(routes.dashboard)}
                  >
                    <img
                      src={blitzLogo}
                      alt="logo"
                      style={{ height: "45px" }}
                    />
                  </IconButton>
                </Box>
                {children}
                {/* Mobile: Action buttons instead of menu button */}
                {mobileActions.map((action) => (
                  <Tooltip key={action.key} title={action.tooltip} placement="bottom">
                    <IconButton
                      color="inherit"
                      onClick={action.onClick}
                      sx={{ ml: 1 }}
                      aria-label={action.tooltip}
                    >
                      {action.icon}
                    </IconButton>
                  </Tooltip>
                ))}
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default BlitzHeader;